import { render, staticRenderFns } from "./stock-rotations-form.vue?vue&type=template&id=b090464c&scoped=true&"
import script from "./stock-rotations-form.vue?vue&type=script&lang=js&"
export * from "./stock-rotations-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b090464c",
  null
  
)

export default component.exports